import React from "react";
import { Link } from "react-router-dom";

// Shared page chrome for editorial/content pages (guides, storyboard pages).
// Matches the Georgia-serif, beige, 2px-border page pattern used across the site.
export default function ContentPageLayout({ children }) {
  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <Link to="/" style={styles.logo}>striply</Link>
        <nav style={styles.nav}>
          <Link to="/guides" style={styles.navLink}>Guides</Link>
          <Link to="/storyboard" style={styles.navLink}>Storyboards</Link>
          <Link to="/tutorial" style={styles.navLink}>Tutorial</Link>
          <Link to="/editor" style={styles.navLink}>Editor</Link>
          <Link to="/about" style={styles.navLink}>About</Link>
        </nav>
      </header>

      {children}

      <footer style={styles.footer}>
        <nav style={styles.footerNav}>
          <Link to="/" style={styles.footerLink}>Home</Link>
          <Link to="/guides" style={styles.footerLink}>Guides</Link>
          <Link to="/storyboard" style={styles.footerLink}>Storyboard maker</Link>
          <Link to="/storyboard-templates" style={styles.footerLink}>Storyboard templates</Link>
          <Link to="/tutorial" style={styles.footerLink}>Tutorial</Link>
          <Link to="/editor" style={styles.footerLink}>Editor</Link>
          <Link to="/about" style={styles.footerLink}>About</Link>
          <Link to="/privacy" style={styles.footerLink}>Privacy</Link>
          <Link to="/terms" style={styles.footerLink}>Terms</Link>
        </nav>
      </footer>
    </div>
  );
}

const styles = {
  container: {
    fontFamily: "'Georgia', 'Times New Roman', serif",
    color: "#1a1a1a",
    lineHeight: 1.7,
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    background: "#f5f0e8",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 40px",
    borderBottom: "2px solid #1a1a1a",
    flexWrap: "wrap",
    gap: 12,
  },
  logo: {
    fontSize: 28,
    fontWeight: 700,
    color: "#1a1a1a",
    textDecoration: "none",
    fontFamily: "'Georgia', serif",
  },
  nav: { display: "flex", gap: 20, flexWrap: "wrap" },
  navLink: {
    color: "#555",
    textDecoration: "none",
    fontSize: 15,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  footer: {
    padding: "24px 40px",
    borderTop: "2px solid #1a1a1a",
    background: "#f5f0e8",
  },
  footerNav: {
    display: "flex",
    justifyContent: "center",
    gap: 28,
    flexWrap: "wrap",
  },
  footerLink: {
    color: "#666",
    textDecoration: "none",
    fontSize: 14,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
};

// Scoped typography for the prose body — cleaner than inline-styling every
// paragraph. Injected once, mirrors the TutorialPage media-query pattern.
// Shared by guides and storyboard template pages.
if (typeof document !== "undefined" && !document.querySelector("[data-guide-style]")) {
  const el = document.createElement("style");
  el.setAttribute("data-guide-style", "");
  el.textContent = `
    .guide-content { font-size: 16px; color: #333; line-height: 1.75; }
    .guide-content p { margin: 0 0 18px; }
    .guide-content h2 {
      font-size: 24px; font-weight: 700; color: #1a1a1a;
      margin: 36px 0 12px; line-height: 1.3;
    }
    .guide-content ul { margin: 0 0 18px; padding-left: 22px; }
    .guide-content li { margin-bottom: 8px; }
    .guide-content strong { color: #1a1a1a; }
    .guide-content a { color: #00a4e4; text-decoration: none; }
    .guide-content a:hover { text-decoration: underline; }
    .guide-content em { font-style: italic; }
  `;
  document.head.appendChild(el);
}
